import { useSocketSubscription } from 'app/scripts/init/useSocketSubscription';
import { useMemberInboxIds } from './useMemberInboxIds';

/*
 * Set up websocket subscription for the inbox board to receive updates
 */
export const useInboxSocketSubscription = () => {
  const { idBoard: inboxBoardId } = useMemberInboxIds();
  useSocketSubscription('Board', inboxBoardId, !inboxBoardId);
};
